module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-anja.ddd8ec61.jpeg";